import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../../constants';
import awsBucketName from '../../../../constants';
import axios from 'axios';
import {SearchApi} from '../../../../services/B2BModule/SearDataAPI';
import {GetAllHubData} from '../../../../services/B2BModule/CommonFuntion';
import editComponentOfRMApproval from '../../../B2B components/editComponentOfRMApproval'
import {update} from '../../../../services/B2b/services/update';
import {imageList} from '../../../../services/B2b/services/imageList';
import {fetchImage} from '../../../../services/B2b/services/fetchImages';
import { custom_sort } from '../../../../services/utility';
import {externalDisputeAction } from '../../../../services/externalDispute';
import { actionStatuses } from '../../../../services/actionStatus';


export default {
    name: 'EditOprationExecutive',
    components: {
        VueElementLoading,
        Multiselect,
        editComponentOfRMApproval

    },
    data() {
        return {
            awbnumberObject: {},
            token: '',
            show: false,
            alldata: {},
            submitDisable: true,
            token: '',
            imagesarr: [],
            attachment: null,
            displaytable: false,
            newhubs: '',
            Reason: '',
            images: [],
            username:'',
            fieldsAccessData: {}

        }
    },
    mounted() {
        const userToken = window.localStorage.getItem('accessuserToken');
        this.token = userToken.replace(/"/g, '');
        this.username = window.localStorage.getItem('username');
        this.awbnumber = this.$route.query.awb;
        this.awbnumberObject = {
            awbnumber : this.$route.query.awb
        }
    },
    methods: {
        Backinvestigation() {
            this.$router.push({ path: '/RMApprovalPending' });

          },
          
          updateData(ShippingID,actionstatucodeid,description){
            if(!actionstatucodeid) this.$alertify.error("Please Select Take Action")
            else if(!description) this.$alertify.error("Please Fill Description")
            else if(description.length < 20) this.$alertify.error("Description should be greater than 20 charectors")
            else{
            let input = {
                ShippingID : ShippingID,
                username : window.localStorage.getItem('username'),
                actionstatuscode : actionstatucodeid.toString(),
                comments:description
        
            }
            externalDisputeAction(input,this.token).then(result => {
                if(result.data.ReturnCode == 100){
                    this.$alertify.success(result.data.ReturnMessage);
                    this.$router.push({ path: '/RMApprovalPending' });
                }else{
                    this.$alertify.error(result.ReturnMessage);
                }
            })
        }
        },
       
    }
}



// WEBPACK FOOTER //
// ./src/views/components/RMApproval/editRMApprovalPending/editRMApprovalPending.component.js